import { EMPTY_GUID } from "../constants";

export const undefinedValueCheck = (value: unknown, message: string) => {
    if (value == null) {
        throw new Error(message);
    }
};

export const isNullUndefinedOrEmptyGuid = (id: string) => id === undefined || id === null || id === EMPTY_GUID;
